import { css } from '@emotion/react';

export default css`
  .ant-modal .ant-modal-footer {
    margin-top: 20px;
  }
`;
